import '@babel/polyfill';

import Vue from 'vue';
import vuetify from './plugins/vuetify';

import App from './App.vue';
import router from './router';

import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

import './styles/global.scss';

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  vuetify,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event('x-app-rendered')),
});
